import React from "react";
import { observer, inject } from "mobx-react";
import * as M from "@material-ui/core";
import ReactMarkdown from "react-markdown";

const DisclaimerInfo = ({ store }) => {
  const { $user, $locale } = store;
  return (
    <M.Dialog
      open={$user.sessionUser.showDisclaimerInfo}
      onClose={() => $user.sessionUser.change("showDisclaimerInfo", false)}
    >
      <M.DialogContent>
        <ReactMarkdown source={$locale.t("disclaimer_body")} renderers={{ link: LinkRenderer }} />
      </M.DialogContent>
      <M.DialogActions>
        <M.Button
          variant="text"
          onClick={() => $user.sessionUser.change("showDisclaimerInfo", false)}
        >
          {$locale.t("cancel")}
        </M.Button>
        <M.Button
          onClick={() => {
            $user.sessionUser.change("showDisclaimerInfo", false);
            $user.sessionUser.change("disclaimer", true);
          }}
        >
          {$locale.t("scale_e") || "OK"}
        </M.Button>
      </M.DialogActions>
    </M.Dialog>
  );
};

const LinkRenderer = props => {
  return (
    <a href={props.href} target="_blank">
      {props.children}
    </a>
  );
};

export default inject("store")(observer(DisclaimerInfo));
